import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/workspaces/{id}/activity?limit= — recent workspace activity feed. */
export function useWorkspaceActivity(workspaceId, limit = 20, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.workspaceActivity(workspaceId, limit),
    queryFn: ({ signal }) => apiGet(`/workspaces/${workspaceId}/activity?limit=${limit}`, signal),
    enabled: !!workspaceId && (enabled ?? true),
    ...rest,
  });
}
